import { z } from 'zod';
import { changesSchema } from './changes.js';
import { idSchema } from './common.js';
/**
 * Fix with AI on one scene's characters — GEN-135. A request in an author's words becomes
 * a proposed visual; Apply writes it as a hand edit would, and Revert puts back the fields
 * it changed. `docs/decisions/scene-visual-fix.md`.
 */
/** POST /authoring/scenes/:id/visual-fixes */
export const requestVisualFixSchema = z
    .strictObject({
    lessonId: idSchema.describe('The lesson the scene is placed in.'),
    request: z
        .string()
        .trim()
        .min(1)
        .max(300)
        .describe('What to change, as the author would say it.'),
})
    .describe('Ask for a change to one scene’s characters and props.');
export const visualFixStatusSchema = z
    .enum(['PROPOSED', 'APPLIED', 'REVERTED', 'DISCARDED'])
    .describe('Waiting for Apply; written to the scene; written then put back; turned down.');
export const visualFixSchema = z
    .strictObject({
    id: idSchema,
    lessonId: idSchema,
    sceneId: idSchema.describe('The scene as Apply wrote it.'),
    position: z.number().int().min(1).describe('The scene’s place, 1-based.'),
    request: z.string(),
    status: visualFixStatusSchema,
    why: z.string().describe('What the fixer changed, in its words.'),
    changes: changesSchema.shape.changes.describe('Every field of the visual that differs, before and after.'),
    createdAt: z.iso.datetime(),
    appliedAt: z.iso.datetime().optional(),
    revertedAt: z.iso.datetime().optional(),
})
    .describe('One Fix with AI on a scene’s visual, from proposal to revert.');
export const visualFixesSchema = z
    .strictObject({ fixes: z.array(visualFixSchema).describe('Newest first.') })
    .describe('A lesson’s visual fixes.');
//# sourceMappingURL=visual-fix.js.map